import React from 'react';
import styles from '../livia_santos_gastronomia/livia_santos_gastronomia.module.scss';
import LinkPersonalizado from '../../components/LinkPersonalizado/linkPersonalizado.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';

const Livia_santos_gastronomia: React.FC = () => {

    return (
        <div className={styles.livia_santos_gastronomia}>

            <div className={styles["body-thunder"]}>
                {/* <div className={styles.menuBar} style={{ width: "100%", backgroundColor: 'rgb(58 57 54)' }}>
                <div className={styles["switch-container"]}>
                    <div className={styles.switchItem}>
                        <span
                            style={{
                                backgroundColor: '#cbb353',
                                padding: '0.5rem',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                color: 'white'
                            }}
                        >
                            Perfil principal
                        </span>
                    </div>
                    <div className={styles.switchItem}>
                        <Link
                            to="/lanchonete_peaozinho_"
                            style={{
                                padding: '0.5rem',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                color: 'white'
                            }}
                        >
                            Restaurante
                        </Link>
                    </div>
                </div>
            </div> */}
                <div className={`${styles["container-thunder"]}`} >
                    <h1 className="mb-0">LÍVIA SANTOS RONCARATTI</h1>
                    <p className="mb-3">GASTRONOMIA</p>
                    <div className={styles.links}>
                        <LinkPersonalizado
                            href="https://wa.me/5517981302523"
                            title="Contato"
                            icon={<WhatsappIcon height="40" color="#fff" />}
                            colorText="#000"
                            showIcon={false}
                        />
                        <LinkPersonalizado
                            href="https://www.instagram.com/livia_santos_gastronomia?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                            title="Instagram"
                            icon={<InstagramIcon height="32" color="#fff" />}
                            colorText="#000"
                            showIcon={false}
                        />
                        <LinkPersonalizado
                            href="https://www.instagram.com/jamieolivercookeryschool?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                            title="Formação em Gastronomia"
                            icon={<InstagramIcon height="32" color="#fff" />}
                            colorText="#000"
                            showIcon={false}
                        />
                        <LinkPersonalizado
                            href="https://wa.me/5517981302523?text=Olá gostaria de mais informações sobre eventos/encomendas."
                            title="Eventos e Encomendas"
                            icon={<WhatsappIcon height="32" color="#fff" />}
                            colorText="#000"
                            showIcon={false}
                        />
                    </div>
                </div>
            </div>
        </div >
    );
};

export default Livia_santos_gastronomia;
